module.exports = __webpack_public_path__ + "./fonts/Proxima-Bold.otf";